import * as AzureStorageBlob from "@azure/storage-blob";
import alert from "./alert";
const { REACT_APP_IMG_SAS,
 REACT_APP_DOC_SAS,
  REACT_APP_BLOB_ACCOUNT } = process.env;

  console.log(REACT_APP_IMG_SAS,REACT_APP_DOC_SAS)
const URL = `https://atbstore.blob.core.windows.net?`;
const DEAFULT_CONFIG: any = {
    doc: {
        sas: REACT_APP_DOC_SAS,
        container: 'recruitment-docs'
    },
    img: {
        sas: REACT_APP_IMG_SAS,
        container: 'recruitment-images'
    }
}
class AzureBlob {
    client: any = null
    config: any = {};

    constructor(key: any) {
        const { sas, container } = DEAFULT_CONFIG[key];
        this.config = { sas, container };
        this.client = new AzureStorageBlob.BlobServiceClient(`${URL}${sas}`).getContainerClient(container);
    }

    async getBlobInContainer(): Promise<string[]> {
        const returnedBlobUrls: string[] = [];
        //get list of blobs in container
        // eslint-disable-next-line
        for await (const blob of this.client.listBlobsFlat()) {
            // if image is public, just construct URL
            if (!blob.name.includes("jobs")) continue
            returnedBlobUrls.push(
                `${URL}${this.config.container}/${blob.name}`
            );
        }

        return returnedBlobUrls;
    }

    async uploadFile({ file, fileName }: any) {
        try {
            // create blobClient for container
            const blobClient = this.client.getBlockBlobClient(`jobs/${fileName}`);

            // set mimetype as determined from browser with file upload control
            const options = { blobHTTPHeaders: { blobContentType: file.type } };

            // upload file
            await blobClient.uploadData(file, options);
            return blobClient.url;
            // const blobClient = this.client.getBlockBlobClient(fileName);
            // const blobResponse = await blobClient.upload(file, file.length)
        } catch (e) {
            alert(({
                text: "Upload Failed",
                icon: "error"
            }))
            return null;
        }

    }

}

export default AzureBlob;